export default function Addorders() {
  return (
    <div className="box-btn d-flex justify-content-center mt-4">
      <div className="btn">
        <button
          style={{
            marginLeft: "10px",
            backgroundColor: "#457b9d",
            color: "white",
            border: "none",
            borderRadius: "15px",
            padding: "8px 20px ",
            fontSize: "18px",
          }}
          data-bs-toggle="modal"
          data-bs-target="#AddOrderModal"
        >
          افزودن سفارشات
        </button>
      </div>
      <div className="btn">
        <button
          style={{
            marginLeft: "10px",
            backgroundColor: "#10451d",
            color: "white",
            border: "none",
            borderRadius: "15px",
            padding: "8px 20px ",
            fontSize: "18px",
          }}
          data-bs-toggle="modal"
          data-bs-target="#AddRepairsModal"
        >
          افزودن تعمیرات
        </button>
      </div>
    </div>
  );
}
